/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ExtService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiExtResetSeqCounterGet
   */
  static readonly ApiExtResetSeqCounterGetPath = '/api/Ext/resetSeqCounter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExtResetSeqCounterGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ExtService.ApiExtResetSeqCounterGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExtResetSeqCounterGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Plain(params?: {
  }): Observable<Array<string>> {

    return this.apiExtResetSeqCounterGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExtResetSeqCounterGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ExtService.ApiExtResetSeqCounterGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExtResetSeqCounterGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtResetSeqCounterGet$Json(params?: {
  }): Observable<Array<string>> {

    return this.apiExtResetSeqCounterGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation apiExtFixPayoutGet
   */
  static readonly ApiExtFixPayoutGetPath = '/api/Ext/fixPayout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExtFixPayoutGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtFixPayoutGet$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ExtService.ApiExtFixPayoutGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExtFixPayoutGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExtFixPayoutGet(params?: {
  }): Observable<void> {

    return this.apiExtFixPayoutGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
